<template>
  <div class="row">
    <div class="col-xl-3 col-md-6" v-for="card in cards" :key="card.key">
      <div class="card position-relative">
        <div class="card-body">
          <transition name="pop" mode="out-in">
            <!-- SKELETON -->
            <div v-if="loading" class="w-100" :key="'s_' + card.key">
              <div class="d-flex align-items-center mb-3">
                <div
                  class="skel"
                  style="width: 44px; height: 44px; border-radius: 12px"
                ></div>
                <div class="ms-3 flex-grow-1">
                  <div
                    class="skel skel-line skel-gap-8"
                    style="width: 70%"
                  ></div>
                  <div class="skel skel-line lg" style="width: 45%"></div>
                </div>
              </div>
              <div class="skel skel-line sm" style="width: 90%"></div>
            </div>

            <!-- CONTENT -->
            <div v-else :key="'c_' + card.key">
              <div class="d-flex align-items-center mb-3">
                <div :class="card.iconWrap">
                  <span class="d-flex align-items-center">
                    <i :class="card.icon"></i>
                  </span>
                </div>
                <div class="ms-3">
                  <p class="fw-medium text-truncate mb-1">{{ card.label }}</p>
                  <h5 class="mb-0">{{ card.value }}</h5>
                </div>
              </div>
            </div>
          </transition>

          <span class="position-absolute top-0 end-0">
            <img src="@/assets/img/bg/card-bg-04.png" alt="Img" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useLeadDashboardStore } from "@/stores/leadDashboardStore";

const dash = useLeadDashboardStore();
const loading = computed(() => dash.loading);
const kpi = computed(() => dash.kpis || {});

function fmtNum(v) {
  return Number(v || 0).toLocaleString();
}

const cards = computed(() => [
  {
    key: "total",
    label: "Total No of Leads",
    value: fmtNum(kpi.value.total_leads),
    iconWrap: "avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0",
    icon: "ti ti-delta text-white fs-16",
  },
  {
    key: "new",
    label: "No of New Leads",
    value: fmtNum(kpi.value.new_leads),
    iconWrap: "avatar avatar-md br-10 icon-rotate bg-secondary flex-shrink-0",
    icon: "ti ti-currency text-white fs-16",
  },
  {
    key: "lost",
    label: "No of Lost Leads",
    value: fmtNum(kpi.value.lost_leads),
    iconWrap: "avatar avatar-md br-10 icon-rotate bg-danger flex-shrink-0",
    icon: "ti ti-stairs-up text-white fs-16",
  },
  {
    key: "customers",
    label: "Total Customers",
    value: fmtNum(kpi.value.total_customers),
    iconWrap: "avatar avatar-md br-10 icon-rotate bg-purple flex-shrink-0",
    icon: "ti ti-users-group text-white fs-16",
  },
]);
</script>
